{{ heading }}<br />
@if (unitModel.unitType !== 'daily') {
    <div>
        {{ unitModel.startDate | localizedDate: 'shortDate' }} -
        {{ unitModel.endDate | localizedDate: 'shortDate' }}
    </div>
} @else {
    {{ unitModel.startDate | localizedDate: 'shortDate' }}
}
